export const showFeatureInStagingEnvironmentsOnly = (includePreprod = true) =>
  process.env.NEXT_PUBLIC_APP_ENVIRONMENT === 'LOCAL' ||
  process.env.NEXT_PUBLIC_APP_ENVIRONMENT === 'INT' ||
  (includePreprod && process.env.NEXT_PUBLIC_APP_ENVIRONMENT === 'PREP');
